<template>
    <div style="display: contents;">
        <tr>
            <td :style="{ paddingLeft: 10 + (25 * level) + 'px' }">{{ item.label }}</td>
            <td>
                <div class="dropdown">
                    <a href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-ellipsis-v"></i>
                    </a>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <button class="dropdown-item" @click="remove(item)">Remove</button>
                    </div>
                </div>
            </td>
        </tr>
        <nested-listing v-if="item.children.length > 0" v-for="child in item.children" :key="child.id" :item="child" :level="level + 1" :parent="item" />
    </div>
</template>

<script>

export default {
    name: "nested-listing",
    props: ['item', 'parent', 'level'],
    data() {
        return {
            deleteCategoryLabel: ''
        }
    },
    methods: {
        remove(item) {
            Bus.$emit('RemoveCategory', item, this.parent);
        }
    }
};
</script>
<style scoped>
.item {
    padding: 5px;
    border-bottom: 1px solid #d4cece;
}
.item-sub {
    margin: 0 0 0 2rem;
}
</style>
